import CryptoJS from "crypto-js";
import {getTokenPrased} from "../security/KeyclockConfig";

const deriveKey = (secretKey: string): CryptoJS.lib.WordArray => {
    return CryptoJS.SHA256(secretKey); // Hash the secret key to ensure consistent length
};

const envSecretKey: string | undefined = process.env.PARAM_ENCRYPT_SECRET_KEY ? process.env.PARAM_ENCRYPT_SECRET_KEY : "";

const generateSecretKey = (): string => {
    // Combine the values

    let tokenPrased = getTokenPrased();

    let auth_time = tokenPrased?.auth_time;
    let sid = tokenPrased?.sid;
    let preferred_username = tokenPrased?.preferred_username;

    const combinedString = `${auth_time}-${sid}-${preferred_username}`;
    // Generate a hash using SHA-256
    const hashedKey = CryptoJS.SHA256(combinedString).toString(CryptoJS.enc.Hex);

    return hashedKey.substring(0, 10);
};


const encryptData = (data: string | object): string => {

    // Convert data to a string
    const stringifiedData = typeof data === "string" ? data : JSON.stringify(data);

    const key = deriveKey(generateSecretKey());

    // Encrypt data
    const encrypted = CryptoJS.AES.encrypt(stringifiedData, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString().replace(/\//g, "_");
};

const encryptObject = (data: object): string => {
    const jsonData = JSON.stringify(data);
    const key = deriveKey(generateSecretKey());

    // Encrypt JSON data
    const encrypted = CryptoJS.AES.encrypt(jsonData, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Convert to Base64 string
    return encrypted.toString();
};
const encryptDataWithEnvKey = (data: string | object): string => {

    // Convert data to a string
    const stringifiedData = typeof data === "string" ? data : JSON.stringify(data);

    const key = deriveKey(envSecretKey);

    // Encrypt data
    const encrypted = CryptoJS.AES.encrypt(stringifiedData, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString().replace(/\//g, "_");
};

const encryptObjectWithEnvKey = (data: object): string => {
    const jsonData = JSON.stringify(data);
    const key = deriveKey(envSecretKey);

    // Encrypt JSON data
    const encrypted = CryptoJS.AES.encrypt(jsonData, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Convert to Base64 string
    return encrypted.toString();
};

// Export encryption utilities
const ParamEncrypt = {
    encryptData,
    encryptObject,
    encryptObjectWithEnvKey,
    encryptDataWithEnvKey
};

export default ParamEncrypt;
